import React from "react";
import { NumericFormat } from "react-number-format";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
//context
import { usePresentacionContext } from "../context/presentacion.context";
import { comprobantesProcess } from "../utilities/comprobantes";

const ComprobantesDataTableTotales = () => {
  const { sumTSeleccionadas, comprobantes ,dataImpuestos,totalImpuestosMF,selectedProductoComercio} =  usePresentacionContext();

  const rowClass = (totales:any) => {
    return {
        'row-diferencia': totales.headerTitle === 'Diferencia'
    }
  }

  const formatMoneyBodyTemplate = (monto: any) => {
    return (
      <React.Fragment>
        <NumericFormat
          value={monto}
          displayType={"text"}
          thousandSeparator={"."}
          decimalSeparator={","}
          prefix={"$"}
          decimalScale={2}
          fixedDecimalScale={true}
        />
      </React.Fragment>
    );
  };

  let { sumTotalSinPercepciones } = comprobantesProcess(comprobantes);
  let totales =  [
    {
      headerTitle:"Total Seleccionado",
      montoTotalDeclarado:sumTSeleccionadas
    },
    {
      headerTitle:"Total Facturado",
      montoTotalDeclarado:sumTotalSinPercepciones
    },
    {
      headerTitle:"Diferencia",
      montoTotalDeclarado:sumTSeleccionadas - sumTotalSinPercepciones
    }
  ]

  return (
    <DataTable
          value={totales}
          responsiveLayout="stack"
          rowClassName={rowClass}
          style={{backgroundColor:"#162056"}}
          >
              <Column field="headerTitle"style={{ width: "10%" }}/>
              <Column field="" style={{ width: "10%" }}/>
              <Column field="" style={{textAlign: 'right',width: "10%" }}/>
              <Column field="" style={{ textAlign: 'right', width: "10%" }} />
              <Column field="" style={{textAlign: 'right',width: "10%" }}/>
              <Column field="" style={{textAlign: 'right',width: "10%" }}/>
              <Column field="" style={{textAlign: 'right',width: "10%" }}/>
              <Column 
                field="montoTotalDeclarado" 
                style={{textAlign: 'right',width: "10%" }}
                body={(rowData) => formatMoneyBodyTemplate(rowData.montoTotalDeclarado)}
                />
              <Column rowEditor style={{ width: "10%" }}/>
      </DataTable>
  );
};

export default ComprobantesDataTableTotales;
